import dayjs from "dayjs";
import { toTitleCase } from "../utils/generalUtils";

// Calculations (for frontend live preview only)
export const calculations = {
  teachingLoadUpou: (values) => {
    const { number_of_students, course_credits, course_type, use_percentage, credit_percentage } = values;

    let student_credit_units = null;
    let teaching_load_credits = null;

    if (number_of_students != null && course_credits != null) {
      student_credit_units = number_of_students * course_credits;
    }

    if (number_of_students != null) {
      if (course_type === "Thesis") {
        teaching_load_credits = 0;
      } else if (course_type === "Capstone") {
        teaching_load_credits =
          number_of_students >= 7 ? 4 : number_of_students * 0.5;
      } else if (course_type === "Regular") {
        teaching_load_credits = number_of_students >= 60 ? 4.5 : 3;
      }

      if (teaching_load_credits != null && use_percentage && credit_percentage != null) {
        teaching_load_credits = teaching_load_credits * (credit_percentage / 100);
      }
    }

    return { student_credit_units, teaching_load_credits };
  },

  teachingLoadOtherUp: (values) => {
    const { number_of_students, course_credits } = values;

    let student_credit_units = null;

    if (number_of_students != null && course_credits != null) {
      student_credit_units = number_of_students * course_credits;
    }

    return { student_credit_units };
  },

  tutorialWork: (values) => {
    const n = values.number_of_students;

    if (n == null) return { approved_credit_units: null };

    let acu = 0;

    if (n <= 10) acu = 0;
    else if (n <= 19) acu = 0.75;
    else if (n <= 30) acu = 1.5;
    else if (n <= 39) acu = 2.25;
    else if (n <= 50) acu = 3;
    else if (n <= 59) acu = 3.75;
    else if (n <= 70) acu = 4.5;
    else if (n <= 79) acu = 5.25;
    else if (n <= 90) acu = 6;
    else if (n <= 99) acu = 6.75;
    else if (n <= 110) acu = 7.5;
    else if (n <= 119) acu = 8.25;
    else if (n <= 130) acu = 9;
    else if (n <= 139) acu = 9.75;
    else if (n <= 150) acu = 10.5;
    else if (n <= 159) acu = 11.25;
    else if (n <= 170) acu = 12;
    else if (n <= 179) acu = 12.75;
    else if (n <= 190) acu = 13.5;
    else if (n <= 199) acu = 14.25;
    else if (n <= 210) acu = 15;
    else if (n <= 219) acu = 15.75;
    else if (n <= 230) acu = 16.5;
    else if (n <= 239) acu = 17.25;
    else if (n <= 250) acu = 18;
    else if (n <= 259) acu = 18.75;
    else if (n <= 270) acu = 19.5;
    else if (n <= 279) acu = 20.25;
    else if (n <= 290) acu = 21;
    else if (n <= 299) acu = 21.75;
    else if (n <= 310) acu = 22.5;
    else if (n <= 319) acu = 23.25;
    else if (n <= 330) acu = 24;
    else if (n <= 339) acu = 24.75;
    else if (n <= 350) acu = 25.5;
    else if (n <= 359) acu = 26.25;
    else if (n <= 370) acu = 27;
    else if (n <= 379) acu = 27.75;
    else if (n <= 390) acu = 28.5;
    else if (n <= 399) acu = 29.25;
    else if (n <= 410) acu = 30;
    else if (n <= 419) acu = 30.75;
    else if (n <= 430) acu = 31.5;
    else if (n <= 439) acu = 32.25;
    else if (n <= 450) acu = 33;
    else if (n <= 459) acu = 33.75;
    else if (n <= 470) acu = 34.5;
    else if (n <= 479) acu = 35.25;
    else if (n <= 490) acu = 36;
    else if (n <= 499) acu = 36.75;
    else if (n <= 510) acu = 37.5;
    else if (n <= 519) acu = 38.25;

    return { approved_credit_units: acu };
  },
};

// Table and modal configurations
export const facultyProfileConfig = {
  teachingLoad: {
    title: "Teaching Load",

    tabs: {
      upou: {
        label: "In UPOU",

        calculate: calculations.teachingLoadUpou,

        columns: [
          {
            title: "Academic Term",
            dataIndex: "academic_term",
            key: "academic_term",
          },
          {
            title: "Course No.",
            dataIndex: "course_number",
            key: "course_number",
          },
          {
            title: "Course Title",
            dataIndex: "course_title",
            key: "course_title",
          },
          {
            title: "Course Type",
            dataIndex: "course_type",
            key: "course_type",
          },
          {
            title: "No. of Students",
            dataIndex: "number_of_students",
            key: "number_of_students",
          },
          {
            title: "Course Credits",
            dataIndex: "course_credits",
            key: "course_credits",
          },
          {
            title: "Student Credit Units",
            dataIndex: "student_credit_units",
            key: "student_credit_units",
          },
          {
            title: "Teaching Load Credits",
            dataIndex: "teaching_load_credits",
            key: "teaching_load_credits",
          },
          {
            title: "Proof",
            dataIndex: "proof",
            key: "proof",
            width: 300,
            render: (value) =>
              value ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {value}
                </a>
              ) : (
                "-"
              ),
          },
        ],

        fields: [
          {
            name: "academic_term",
            label: "Academic Term",
            type: "term-select",
            required: true,
          },
          {
            name: "course_number",
            label: "Course No.",
            type: "course-dropdown",
            required: true,
          },
          {
            name: "course_title",
            label: "Course Title",
            type: "read-only-text",
            required: true,
          },
          {
            name: "course_type",
            label: "Course Type",
            type: "course-type-radio",
            required: true,
          },
          {
            name: "number_of_students",
            label: "No. of Students (A)",
            type: "integer",
            required: true,
          },
          {
            name: "course_credits",
            label: "Course Credits w/o multipliers (B)",
            type: "float",
            required: true,
          },
          {
            name: "use_percentage",
            label: "Team Teaching",
            type: "checkbox",
          },
          {
            name: "credit_percentage",
            label: "Percentage (C%)",
            type: "float",
            showIf: { field: "use_percentage", value: true },
          },
          {
            name: "student_credit_units",
            label: "Student Credit Units",
            type: "read-only-text",
            required: true,
          },
          {
            name: "teaching_load_credits",
            label: "Teaching Load Credits w/ multipliers",
            type: "read-only-text",
            required: true,
          },
          {
            name: "proof",
            label: "Proof (URL)",
            type: "text",
          },
        ],
      },

      otherUp: {
        label: "In Other UP Units",

        calculate: calculations.teachingLoadOtherUp,

        columns: [
          {
            title: "Academic Term",
            dataIndex: "academic_term",
            key: "academic_term",
          },
          {
            title: "UP Unit",
            dataIndex: "up_unit",
            key: "up_unit",
          },
          {
            title: "Course No.",
            dataIndex: "course_number",
            key: "course_number",
          },
          {
            title: "Section Code",
            dataIndex: "section_code",
            key: "section_code",
          },
          {
            title: "Room",
            dataIndex: "room",
            key: "room",
          },
          {
            title: "Days",
            dataIndex: "days",
            key: "days",
          },
          {
            title: "Time",
            dataIndex: "time",
            key: "time",
          },
          {
            title: "Hrs. per week",
            dataIndex: "hours_per_week",
            key: "hours_per_week",
          },
          {
            title: "No. of Students",
            dataIndex: "number_of_students",
            key: "number_of_students",
          },
          {
            title: "Course Credits",
            dataIndex: "course_credits",
            key: "course_credits",
          },
          {
            title: "Student Credit Units",
            dataIndex: "student_credit_units",
            key: "student_credit_units",
          },
          {
            title: "Teaching Load Credits",
            dataIndex: "teaching_load_credits",
            key: "teaching_load_credits",
          },
          {
            title: "Proof",
            dataIndex: "proof",
            key: "proof",
            width: 300,
            render: (value) =>
              value ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {value}
                </a>
              ) : (
                "-"
              ),
          },
        ],

        fields: [
          {
            name: "academic_term",
            label: "Academic Term",
            type: "term-select",
            required: true,
          },
          {
            name: "up_unit",
            label: "UP Unit",
            type: "text",
            required: true,
          },
          {
            name: "course_number",
            label: "Course No.",
            type: "text",
            required: true,
          },
          {
            name: "section_code",
            label: "Section Code",
            type: "text",
            required: true,
          },
          {
            name: "room",
            label: "Room",
            type: "text",
            required: true,
          },
          {
            name: "days",
            label: "Days",
            type: "text",
            required: true,
          },
          {
            name: "time",
            label: "Time",
            type: "text",
            required: true,
          },
          {
            name: "hours_per_week",
            label: "Hrs. per week",
            type: "float",
            required: true,
          },
          {
            name: "number_of_students",
            label: "No. of Students (A)",
            type: "integer",
            required: true,
          },
          {
            name: "course_credits",
            label: "Course Credits w/o multipliers (B)",
            type: "float",
            required: true,
          },
          {
            name: "use_percentage",
            label: "Team Teaching",
            type: "checkbox",
          },
          {
            name: "credit_percentage",
            label: "Percentage (C%)",
            type: "float",
            showIf: { field: "use_percentage", value: true },
          },
          {
            name: "student_credit_units",
            label: "Student Credit Units",
            type: "read-only-text",
            required: true,
          },
          {
            name: "teaching_load_credits",
            label: "Teaching Load Credits w/ multipliers",
            type: "float",
            required: true,
          },
          {
            name: "proof",
            label: "Proof (URL)",
            type: "text",
          },
        ],
      },

      outsideUp: {
        label: "Outside UP",

        columns: [
          {
            title: "Academic Term",
            dataIndex: "academic_term",
            key: "academic_term",
          },
          {
            title: "College",
            dataIndex: "college",
            key: "college",
          },
          {
            title: "No. of Subjects",
            dataIndex: "number_of_subjects",
            key: "number_of_subjects",
          },
          {
            title: "No. of Units",
            dataIndex: "number_of_units",
            key: "number_of_units",
          },
          {
            title: "Proof",
            dataIndex: "proof",
            key: "proof",
            width: 300,
            render: (value) =>
              value ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {value}
                </a>
              ) : (
                "-"
              ),
          },
        ],

        fields: [
          {
            name: "academic_term",
            label: "Academic Term",
            type: "term-select",
            required: true,
          },
          {
            name: "college",
            label: "College",
            type: "text",
            required: true,
          },
          {
            name: "number_of_subjects",
            label: "No. of Subjects",
            type: "integer",
            required: true,
          },
          {
            name: "number_of_units",
            label: "No. of Units",
            type: "float",
            required: true,
          },
          {
            name: "proof",
            label: "Proof (URL)",
            type: "text",
          },
        ],
      },
    },
  },

  research: {
    title: "Research, Textbook Writing, Course Development, & Creative Work",

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "Nature of Involvement",
        dataIndex: "nature_of_involvement",
        key: "nature_of_involvement",
      },
      {
        title: "Start Date",
        dataIndex: "start_date",
        key: "start_date",
      },
      {
        title: "End Date",
        dataIndex: "end_date",
        key: "end_date",
      },
      {
        title: "Funded?",
        dataIndex: "is_funded",
        key: "is_funded",
        render: (value) => (value === 1 || value === true ? "Yes" : "No"),
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "title",
        label: "Title",
        type: "text",
        required: true,
      },
      {
        name: "nature_of_involvement",
        label: "Nature of Involvement",
        type: "text",
        required: true,
      },
      {
        name: "start_date",
        label: "Start Date",
        type: "date",
        required: true,
      },
      {
        name: "end_date",
        label: "End Date",
        type: "date",
        required: true,
      },
      {
        name: "is_funded",
        label: "Funded?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "float",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  administrativeWork: {
    title: "Administrative Work",

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Position/Nature",
        dataIndex: "position",
        key: "position",
      },
      {
        title: "Office/Unit",
        dataIndex: "office",
        key: "office",
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "position",
        label: "Position / Nature of Administration Work",
        type: "text",
        required: true,
      },
      {
        name: "office",
        label: "Office/Unit",
        type: "text",
        required: true,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "float",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  tutorialWork: {
    title: "Tutorial Work",

    calculate: calculations.tutorialWork,

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Course",
        dataIndex: "course",
        key: "course",
      },
      {
        title: "Learning Center",
        dataIndex: "learning_center",
        key: "learning_center",
      },
      {
        title: "No. of Students",
        dataIndex: "number_of_students",
        key: "number_of_students",
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "course",
        label: "Course",
        type: "text",
        required: true,
      },
      {
        name: "learning_center",
        label: "Learning Center",
        type: "text",
        required: true,
      },
      {
        name: "number_of_students",
        label: "No. of Students",
        type: "integer",
        required: true,
        max: 519,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "read-only-text",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  extensionService: {
    title: "Extension and Community Service",

    columns: [
      {
        title: "Academic Term",
        dataIndex: "academic_term",
        key: "academic_term",
      },
      {
        title: "Position/Nature",
        dataIndex: "position",
        key: "position",
      },
      {
        title: "Office/Unit",
        dataIndex: "office",
        key: "office",
      },
      {
        title: "Approved Credit Units",
        dataIndex: "approved_credit_units",
        key: "approved_credit_units",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "academic_term",
        label: "Academic Term",
        type: "term-select",
        required: true,
      },
      {
        name: "position",
        label: "Position / Nature of Extension Work",
        type: "text",
        required: true,
      },
      {
        name: "office",
        label: "Office/Unit",
        type: "text",
        required: true,
      },
      {
        name: "approved_credit_units",
        label: "Approved Credit Units",
        type: "float",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  consultationHours: {
    title: "Consultation Hours",

    columns: [
      {
        title: "Day",
        dataIndex: "day",
        key: "day",
      },
      {
        title: "Start Time",
        dataIndex: "start_time",
        key: "start_time",
        render: (value) =>
          value ? dayjs(value, "HH:mm:ss").format("hh:mm A") : "",
      },
      {
        title: "End Time",
        dataIndex: "end_time",
        key: "end_time",
        render: (value) =>
          value ? dayjs(value, "HH:mm:ss").format("hh:mm A") : "",
      },
      {
        title: "Place",
        dataIndex: "place",
        key: "place",
      },
    ],

    fields: [
      {
        name: "day",
        label: "Day",
        type: "day-select",
        required: true,
      },
      {
        name: "start_time",
        label: "Start Time",
        type: "time",
        required: true,
      },
      {
        name: "end_time",
        label: "End Time",
        type: "time",
        required: true,
      },
      {
        name: "place",
        label: "Place",
        type: "text",
        required: true,
      },
    ],
  },

  studyLoad: {
    title: "Study Load",

    fields: [
      {
        name: "is_enrolled",
        label: "Currently enrolled in a degree?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "degree",
        label: "Degree Enrolled In",
        type: "text",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "university",
        label: "University Enrolled In",
        type: "text",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "total_units",
        label: "Total Units Enrolled In",
        type: "float",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "is_on_leave_with_pay",
        label: "On full study leave with pay?",
        type: "yes-no-radio",
        required: true,
        showIf: {
          field: "is_enrolled",
          value: true,
        },
      },
      {
        name: "is_recipient",
        label: "Recipient of faculty fellowship?",
        type: "yes-no-radio",
        required: true,
      },
    ],
  },

  limitedPractice: {
    title: "Limited Practice of Profession",

    fields: [
      {
        name: "is_applied",
        label:
          "Applied for official permission for limited practice of profession?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "submission_date",
        label: "Date permission was submitted",
        type: "date",
        required: true,
        showIf: {
          field: "is_applied",
          value: true,
        },
      },
      {
        name: "approval_date",
        label: "Date permission was approved",
        type: "date",
        required: true,
        showIf: {
          field: "is_applied",
          value: true,
        },
      },
    ],
  },

  conferencePresentation: {
    title: "Presentations at Conference",

    columns: [
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "Conference Name",
        dataIndex: "conference_name",
        key: "conference_name",
      },
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "title",
        label: "Title",
        type: "text",
        required: true,
      },
      {
        name: "conference_name",
        label: "Conference Name",
        type: "text",
        required: true,
      },
      {
        name: "date",
        label: "Date",
        type: "date",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  seminarWorkshop: {
    title: "Seminars/Workshops Attended",

    columns: [
      {
        title: "Seminar/Workshop Name",
        dataIndex: "seminar_name",
        key: "seminar_name",
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
      },
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "seminar_name",
        label: "Seminar/Workshop Name",
        type: "text",
        required: true,
      },
      {
        name: "role",
        label: "Role",
        type: "text",
        required: true,
      },
      {
        name: "date",
        label: "Date",
        type: "date",
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  advising: {
    title: "Advising",

    columns: [
      {
        title: "Name of Student",
        dataIndex: "student_name",
        key: "student_name",
      },
      {
        title: "Degree Program",
        dataIndex: "degree_program",
        key: "degree_program",
      },
      {
        title: "Academic Term Graduated",
        dataIndex: "academic_term_graduated",
        key: "academic_term_graduated",
      },
      {
        title: "Proof",
        dataIndex: "proof",
        key: "proof",
        width: 300,
        render: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
    ],

    fields: [
      {
        name: "student_name",
        label: "Name of Student",
        type: "text",
        required: true,
      },
      {
        name: "degree_program",
        label: "Degree Program",
        type: "select",
        required: true,
        searchable: true,
        selectItems: [
          { label: "Associate in Arts Program (AA)", name: "AA" },
          { label: "Associate of Arts in Digital Design and Art (AADDA)", name: "AADDA" },
          { label: "Associate of Arts in Digital Entrepreneurship (AADE)", name: "AADE" },
          { label: "Associate of Science in Information Technology (ASIT)", name: "ASIT" },
          { label: "Associate of Science in Instructional Design and Technology (ASIDT)", name: "ASIDT" },
          { label: "Bachelor of Arts in Multimedia Studies (BAMS)", name: "BAMS" },
          { label: "Bachelor of Education Studies (BES)", name: "BES" },
          { label: "Graduate Certificate of Distance Education (GCDE)", name: "GCDE" },
          { label: "Master of Distance Education (MDE)", name: "MDE" },
          { label: "Diploma in Mathematics Teaching (DMT)", name: "DMT" },
          { label: "Diploma in Science Teaching (DST)", name: "DST" },
          { label: "Diploma in Arts in Language and Literacy Education (DLLE)", name: "DLLE" },
          { label: "Master of Arts in Language and Literacy Education (MLLE)", name: "MLLE" },
          { label: "Diploma in Arts in Social Studies Education (DSSE)", name: "DSSE" },
          { label: "Master of Arts in Social Studies Education (MSSE)", name: "MSSE" },
          { label: "PhD in Education (PHD)", name: "PHD" },
          { label: "Professional Teaching Certification (PTC)", name: "PTC" },
          { label: "Graduate Certificate in ASEAN Studies (GCAS)", name: "GCAS" },
          { label: "Master of ASEAN Studies (MAS)", name: "MAS" },
          { label: "Diploma in Environment and Natural Resources Management (DENRM)", name: "DENRM" },
          { label: "Master of Environment and Natural Resources Management (MENRM)", name: "MENRM" },
          { label: "Diploma in International Health (DIH)", name: "DIH" },
          { label: "Master of International Health (MIH)", name: "MIH" },
          { label: "Diploma in Land Valuation and Management (DLVM)", name: "DLVM" },
          { label: "Master of Land Valuation and Management (MLVM)", name: "MLVM" },
          { label: "Diploma in Research & Development Management (DRDM)", name: "DRDM" },
          { label: "Master of Research & Development Management (MRDM)", name: "MRDM" },
          { label: "Diploma in Arts in Social Work (DSW)", name: "DSW" },
          { label: "Master of Arts in Social Work (MSW)", name: "MSW" },
          { label: "Master of Climate and Disaster Resilience (MCDR)", name: "MCDR" },
          { label: "Master of Arts in Nursing (MAN)", name: "MAN" },
          { label: "Master of Public Management (MPM)", name: "MPM" },
          { label: "Diploma in Computer Science (DCS)", name: "DCS" },
          { label: "Master of Development Communication (MDC)", name: "MDC" },
          { label: "Master of Information Systems (MIS)", name: "MIS" },
          { label: "Doctor of Communication (DComm)", name: "DComm" },
          { label: "Diploma in Women and Development (DWD)", name: "DWD" },
          { label: "Diploma in Land Use Planning (DLUP)", name: "DLUP" },
        ],
      },
      {
        name: "academic_term_graduated",
        label: "Academic Term Graduated",
        type: "term-select",
        extended: true,
        required: true,
      },
      {
        name: "proof",
        label: "Proof (URL)",
        type: "text",
      },
    ],
  },

  recipientOrNominee: {
    title: "Professorial Chair or Faculty Grant Recipient or Nominee",

    fields: [
      {
        name: "is_recipient_or_nominee",
        label: "Are you a recipient/nominee?",
        type: "yes-no-radio",
        required: true,
      },
      {
        name: "is_nominated_but_no_appt",
        label:
          "No appointment has been approved as of today but faculty has already nominated?",
        type: "yes-no-radio",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "nomination",
        label: "What are you nominated for?",
        type: "nomination-radio",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "title",
        label: "Chair/Grant Title",
        type: "text",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "start_date",
        label: "Approved Start Date",
        type: "date",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
      {
        name: "end_date",
        label: "Approved End Date",
        type: "date",
        required: true,
        showIf: {
          field: "is_recipient_or_nominee",
          value: true,
        },
      },
    ],
  },
};
